import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

// Gate for admin-only pages (SYSTEM_ADMIN = "Admin"). Validateurs are bounced back to the queue.
export function AdminRoute() {
  const { isAdmin } = useAuth();
  if (!isAdmin) {
    return <Navigate to="/address-validations" replace />;
  }
  return <Outlet />;
}
